import Video from '../../../Assets/videos/plaftform.mp4'

const MigrantsVideo = () => {
  return (
    <div className="migrants-video-container row">
      <div className="col-12 video-section">
        <h5 className="title-migrates">¿Cómo generar tu usuario?</h5>
        <p className="text-migrates">
          Conoce como generar tu usuario dando clic al vídeo
        </p>
        <video width="100%" controls>
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>
      </div>
    </div>
  )
}

export default MigrantsVideo
